import apiService from '../Api'
import {
  EligibleMovementRequest,
  JobRequisitionDetail,
  JobRequisitionFilters,
  JobRequisitionInput,
  JobRequisitionPage,
  JobRequisitionSigner
} from './types'

/** "Vagas de Emprego": job requisitions (RP) opened from MPs and signed in the panel (ABRA-320). */
export class JobRequisitionService {
  async list(filters: JobRequisitionFilters): Promise<JobRequisitionPage> {
    // Laravel's `boolean` rule takes 1, not the string "true" a query param would carry.
    const params = { ...filters, to_sign: filters.to_sign ? 1 : undefined }
    return apiService.get('/job-requisitions', { params }).then((response) => response.data)
  }

  async show(id: number): Promise<JobRequisitionDetail> {
    return apiService.get(`/job-requisitions/${id}`).then((response) => response.data)
  }

  /** Finished MPs that can open an RP. */
  async eligibleMovementRequests(): Promise<EligibleMovementRequest[]> {
    return apiService.get('/job-requisitions/movement-requests').then((response) => response.data)
  }

  /** Users with the "Assinar RP" permission. */
  async signers(): Promise<JobRequisitionSigner[]> {
    return apiService.get('/job-requisitions/signers').then((response) => response.data)
  }

  async create(input: JobRequisitionInput): Promise<JobRequisitionDetail> {
    return apiService.post('/job-requisitions', input).then((response) => response.data)
  }

  async update(id: number, input: JobRequisitionInput): Promise<JobRequisitionDetail> {
    return apiService.put(`/job-requisitions/${id}`, input).then((response) => response.data)
  }

  /** A signed RP: only the areas and the portfolio link, which the site shows. */
  async updateSite(
    id: number,
    input: Pick<JobRequisitionInput, 'areas' | 'allow_portfolio_link'>
  ): Promise<JobRequisitionDetail> {
    return apiService.put(`/job-requisitions/${id}`, input).then((response) => response.data)
  }

  async sign(id: number): Promise<JobRequisitionDetail> {
    return apiService.post(`/job-requisitions/${id}/sign`).then((response) => response.data)
  }

  async reject(id: number, reason: string): Promise<JobRequisitionDetail> {
    return apiService.post(`/job-requisitions/${id}/reject`, { reason }).then((response) => response.data)
  }

  async close(id: number, closedAt: string): Promise<JobRequisitionDetail> {
    return apiService.post(`/job-requisitions/${id}/close`, { closed_at: closedAt }).then((response) => response.data)
  }

  async cancel(id: number, reason: string): Promise<JobRequisitionDetail> {
    return apiService.post(`/job-requisitions/${id}/cancel`, { reason }).then((response) => response.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/job-requisitions/${id}`)
  }
}
